module.exports = __webpack_public_path__ + "img/efficiency.66dc9b19.png";